import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';

export const authGuard: CanActivateFn = (): boolean => {
  // Skip auth check on localhost — the IDP cookie is domain-scoped and
  // will never be present on localhost. Works fine on deployed domains.
  if (window.location.hostname === 'localhost') {
    return true;
  }

  const hasToken = document.cookie
    .split('; ')
    .some((row) => row.startsWith('X-JWT-TOKEN=') && row.split('=')[1]?.trim().length > 0);

  if (!hasToken) {
    const idpUrl = inject(EnvironmentFacadeService).IDP();
    window.location.replace(idpUrl);
    return false;
  }

  return true;
};
